export function useStorage<T>(key: string, defaultValue: T) {
  const storageKey = `__storage_${key}__`;
  let data: T;
  try {
    const result = JSON.parse(localStorage.getItem(storageKey) || '');
    if (result === null) {
      data = defaultValue;
    } else {
      data = result;
    }
  } catch {
    data = defaultValue;
  }

  type CallableValue = ((value: T) => T) | ((value: T) => void);

  function isFunction(value: any): value is CallableValue {
    return typeof value === 'function';
  }
  function isReturnVoid(value: any): value is void {
    return value === undefined;
  }

  function setValue(value: T | CallableValue) {
    if (isFunction(value)) {
      const nextValue = value(data);
      if (isReturnVoid(nextValue)) {
        data = { ...data };
      } else {
        data = nextValue;
      }
    } else {
      data = value;
    }
    localStorage.setItem(storageKey, JSON.stringify(data));
  }

  function getValue() {
    return data;
  }

  const returns = [getValue, setValue] as const;

  return returns;
}
